import React from 'react';
import styled from 'styled-components';
import { media, theme } from 'styles';
import { animateScroll as scroll } from 'react-scroll';
import bannerImage from 'images/banners/BAM-banner.jpg';
import { Breadcrumbs, Button, Container, TypingHero } from 'components/shared';
import routes from 'helpers/routes';

const { sp, colors } = theme;

const Banner = styled.div`
  position: relative;
  background-image: url('${props => props.src}');
  background-size: cover;
  background-position: top right -270px;
  background-repeat: no-repeat;
  padding: 60px 0 100px;

  h1 {
    color: ${colors.white};
    max-width: 600px;
    font-size: 40px;
    line-height: 48px;
    margin-top: ${sp.l};
    margin-bottom: ${sp.s};
    font-weight: 500;

    ${media.tablet`
      font-size: 48px;
      line-height: 58px;
    `};
  }

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(43, 88, 153, 0.7);
    content: '';
  }

  ${media.tablet`
    background-position: top right;
    min-height: 700px;

    &::before {
      background-color: rgba(43, 88, 153, 0.3);
    }
  `};
`;

const BannerByline = styled.div`
  margin-top: ${sp.xxl};
  max-width: 600px;
  color: ${colors.white};
`;

export default () => {
  const heading = 'Book a call to';
  const textLines = [
    'Speak to an expert',
    'Discuss your marketing needs',
    'Brainstorm new ideas',
    'Get custom marketing reccos',
    'Manage young marketing talent',
    'Work through planning',
    'Learn more',
  ];
  const breadcrumbs = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: 'Book a Call',
      link: routes.bookMarketer.index,
    },
  ];

  return (
    <Banner src={bannerImage}>
      <Container>
        <Breadcrumbs breadcrumbs={breadcrumbs} left light />
        <TypingHero heading={heading} lines={textLines} light />
        <Button yellow scroll onClick={() => scroll.scrollTo(600)}>
          Book Now
        </Button>
        <BannerByline>
          Whether you need a marketer to brainstorm with or help figuring out
          how to allocate your marketing budget, we’ve got you covered!
        </BannerByline>
      </Container>
    </Banner>
  );
};



// WEBPACK FOOTER //
// ./src/components/BookMarketerPage/components/Header/Header.jsx